import { Api } from 'utils';

class ValidationService {
  static lawyer = {
    check: async (params?: any) => Api.createResponse('lawyer/validation/check', params),
    checkInpre: async (params?: any) => Api.createResponse('app/home/check-inpre', params),
    verify: async (params?: any) => Api.createResponse('app/home/verify', params),
    updateDocs: async (params?: any) => Api.createResponse('app/home/update-docs', params), // Nuevo endpoint para el reemplazo de documentos
  };
}

export default ValidationService;
